import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ArrowRight } from 'lucide-react';

const labels = {
  ne: {
    title: 'सुझाव र प्रतिक्रिया',
    subtitle: 'तपाईंको सुझाव तथा प्रतिक्रियाले हामीलाई अझ राम्रो बनाउन सहयोग गर्दछ।',
    ctaBtn: 'सुझाव र प्रतिक्रिया दिनुहोस्',
  },
  en: {
    title: 'Suggestions & Feedback',
    subtitle: 'Your suggestions and feedback help us make things even better.',
    ctaBtn: 'Give Suggestions & Feedback',
  },
};

const SectorFeedback = ({ sectorTitle, language = 'ne' }) => {
  const t = labels[language] || labels.ne;
  const feedbackUrl = sectorTitle
    ? `/suggestions-feedback?sector=${encodeURIComponent(sectorTitle)}`
    : '/suggestions-feedback';

  return (
    <section className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden p-8 md:p-10 my-8">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex items-start gap-4">
          <div
            className="w-12 h-12 rounded-xl flex items-center justify-center text-xl shrink-0"
            style={{ background: 'rgb(21, 75, 43)' }}
          >
            <MessageSquare size={22} className="text-white" />
          </div>
          <div>
            <h3 className="text-xl font-extrabold text-gray-900 font-[var(--ff-nepali)]">
              {t.title}
            </h3>
            <p className="text-sm text-gray-600 mt-1 max-w-xl font-[var(--ff-nepali)] leading-relaxed">
              {t.subtitle}
            </p>
          </div>
        </div>

        <div className="shrink-0">
          <Link
            to={feedbackUrl}
            className="inline-flex items-center gap-2 rounded-xl bg-[#154B2B] px-6 py-3.5 text-sm font-bold text-white shadow-md transition-all duration-300 hover:bg-[#0f351f] hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0"
          >
            <span>{t.ctaBtn}</span>
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SectorFeedback;